module.exports = __webpack_public_path__ + "assets/img/qualityInspection.fc07f240.png";